import { BanIcon, CheckIcon, CleanIcon, EyeOffIcon, LogoutIcon, SendIcon, TrashIcon, UndoIcon, UnfollowIcon } from '../../Brand/Icon';
import React, { useId } from "react";
import './index.scss';
import { useTranslation } from 'react-i18next';

// Keep the meaning of the pair consistent across editors, forms and settings.
const ACTIONS = {
  save: { icon: CheckIcon },
  delete: { icon: TrashIcon, destructive: true },
  clear: { icon: CleanIcon, destructive: true },
  logout: { icon: LogoutIcon, destructive: true },
  unfollow: { icon: UnfollowIcon, destructive: true },
  block: { icon: BanIcon, destructive: true },
  hide: { icon: EyeOffIcon },
  send: { icon: SendIcon },
};

export default function ControlButton({
  onOK, onCancel, action = 'save', disabledOk = false, busy = false,
  disabledCancel = busy, form, className = '', cancelLabel, confirmLabel, busyLabel,
  cancelClassName = '', confirmClassName = '',
}) {
  const { t } = useTranslation();
  const busyDescription = useId();
  const { icon: ConfirmIcon, destructive } = ACTIONS[action] || ACTIONS.save;
  return <div className={`control-button wiw-control-band${destructive ? ' control-button--destructive' : ''} ${className}`.trim()}>
    <button type="button" className={`wiw-control-button control-button-cancel ${cancelClassName}`.trim()}
      aria-label={cancelLabel || t('common.cancel', { defaultValue: 'Cancel' })}
      onClick={onCancel} disabled={disabledCancel}>
      <span className="wiw-control-button__face"><UndoIcon /></span>
    </button>
    <button type={form ? 'submit' : 'button'} form={form} className={`wiw-control-button control-button-ok ${confirmClassName}`.trim()}
      aria-label={confirmLabel || t('common.save', { defaultValue: 'Save' })} aria-busy={busy}
      aria-describedby={busy ? busyDescription : undefined}
      onClick={onOK} disabled={disabledOk || busy}>
      <span className="wiw-control-button__face">
        <ConfirmIcon />
      </span>
      {busy && <span id={busyDescription} hidden>{busyLabel || t('brand:loading')}</span>}
    </button>
  </div>;
}
